import http from "../../http";

/** 问卷/活动对比分析（旧 /old/api/pc/matchUser → oldpeople 网关） */
const BASE = "/gateway/apps/oldpeople/api/pc/matchUser";

const matchUser = {
  selectByPage(param) {
    return http.spin.payload(`${BASE}/selectByPage`, param);
  },
  matchSummary(param) {
    return http.payload(`${BASE}/matchSummary`, param);
  },
  exportMatchUserList(param) {
    return http.payload(`${BASE}/exportMatchUserList`, param);
  },
};

export default matchUser;
